import React from 'react';

const InfoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
    <circle cx="24" cy="24" r="20" fill="#19A54A" />
    <circle cx="24" cy="16" r="2" fill="white" />
    <path d="M24 21V32" stroke="white" strokeWidth="2.5" strokeLinecap="round" />
  </svg>
);

export default InfoIcon;
